<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="nonconformance_hold_tag.hold_tag_id && nonconformance_hold_tag.hold_tag_id > 0"
                            @invoke-method="dbGetNonconformanceHoldTag(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="nonconformance_hold_tag.hold_tag_id && nonconformance_hold_tag.hold_tag_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('nonconformance_hold_tags.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in nonconformance_hold_tag_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != nonconformance_hold_tag.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('nonconformance_hold_tags.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_nonconformance_hold_tag.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'nonconformance_hold_tags' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="nonconformance_hold_tag.status" class="ribbon ribbon-top-right" :class="`ribbon-${nonconformance_hold_tag.status_class}`">
                            <span class="ribbon-span">{{ nonconformance_hold_tag.status }}</span>
                        </div>
                        <v-form ref="formNonconformanceHoldTag">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="nonconformance_hold_tag_dialog"
                                    v-model="nonconformance_hold_tag.hold_tag_id"
                                    :label="`${$t('lang.hold_tag_id')} *`"
                                    :counter="showCounter(nonconformance_hold_tag.hold_tag_id, 'nonconformance_hold_tags.hold_tag_id')"
                                    :rules="ifValid('nonconformance_hold_tags.hold_tag_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="nonconformance_hold_tag.nonconformance_id"
                                    :label="$t('lang.nonconformance_id')"
                                    :counter="showCounter(nonconformance_hold_tag.nonconformance_id, 'nonconformance_hold_tags.nonconformance_id')"
                                    :rules="ifValid('nonconformance_hold_tags.nonconformance_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="nonconformance_hold_tag.reason"
                                    :label="`${$t('lang.reason')} *`"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('nonconformance_hold_tags.reason')"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.verified_by"
                                    :label="$t('lang.verified_by')"
                                    :items="verified_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.verified_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.verified_date"
                                    :label="$t('lang.verified_date')"
                                    :rules="ifValid('nonconformance_hold_tags.verified_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="nonconformance_hold_tag.nine_point_submission"
                                    :label="`${$t('lang.nine_point_submission')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.nine_point_submission_by"
                                    :label="$t('lang.nine_point_submission_by')"
                                    :items="nine_point_submission_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.nine_point_submission_date"
                                    :label="$t('lang.nine_point_submission_date')"
                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="nonconformance_hold_tag.strip_chart"
                                    :label="`${$t('lang.strip_chart')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.strip_chart')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.strip_chart_by"
                                    :label="$t('lang.strip_chart_by')"
                                    :items="strip_chart_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.strip_chart_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.strip_chart_date"
                                    :label="$t('lang.strip_chart_date')"
                                    :rules="ifValid('nonconformance_hold_tags.strip_chart_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="nonconformance_hold_tag.recipe_sheet"
                                    :label="`${$t('lang.recipe_sheet')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.recipe_sheet_by"
                                    :label="$t('lang.recipe_sheet_by')"
                                    :items="recipe_sheet_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.recipe_sheet_date"
                                    :label="$t('lang.recipe_sheet_date')"
                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="nonconformance_hold_tag.process_sheet"
                                    :label="$t('lang.process_sheet')"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.process_sheet')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.process_sheet_by"
                                    :label="$t('lang.process_sheet_by')"
                                    :items="process_sheet_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.process_sheet_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.process_sheet_date"
                                    :label="$t('lang.process_sheet_date')"
                                    :rules="ifValid('nonconformance_hold_tags.process_sheet_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="nonconformance_hold_tag.customer_contacted_by"
                                    :label="$t('lang.customer_contacted_by')"
                                    :items="customer_contacted_by"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('nonconformance_hold_tags.customer_contacted_by')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="nonconformance_hold_tag.customer_contacted_date"
                                    :label="$t('lang.customer_contacted_date')"
                                    :rules="ifValid('nonconformance_hold_tags.customer_contacted_date')"
                                ></bc-date-picker>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'nonconformance_hold_tags' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveNonconformanceHoldTags">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_nonconformance_hold_tag"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_nonconformance_hold_tag')"
                :message="$t('lang.delete_nonconformance_hold_tag_confirm')"
                @onConfirm="deleteNonconformanceHoldTags()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_nonconformance_hold_tag_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteNonconformanceHoldTagDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            nonconformance_hold_tag: {},
            file_name: "",
            dbGetNonconformanceHoldTag: _.debounce(this.getNonconformanceHoldTag, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchNonconformanceHoldTag", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.nonconformance_hold_tag) {
                        this.nonconformance_hold_tag = this.assignObj2(data.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=nonconformance_hold_tag_status&sort_by=2",
                            method: "get",
                            stateProperty: "nonconformance_hold_tag_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "nonconformance_hold_tags", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchNonconformanceHoldTag", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.nonconformance_hold_tag) {
                        next((vm) => {
                            vm.nonconformance_hold_tag = vm.assignObj2(data.nonconformance_hold_tag, vm.rules_nonconformance_hold_tags);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=nonconformance_hold_tag_status&sort_by=2",
                                method: "get",
                                stateProperty: "nonconformance_hold_tag_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "nonconformance_hold_tags", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=nonconformance_hold_tag_status&sort_by=2",
            method: "get",
            stateProperty: "nonconformance_hold_tag_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.rules_nonconformance_hold_tags,
            nonconformance_hold_tag_status_options: (state) => state.settings.nonconformance_hold_tag_status_options,
            nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.nonconformance_hold_tags,
            selectedNonconformanceHoldTag: (state) => state.nonconformance_hold_tags.selectedNonconformanceHoldTag,
        }),
    },
    methods: {
        ...mapActions(["fetchNonconformanceHoldTag", "saveNonconformanceHoldTag", "deleteNonconformanceHoldTag", "printNonconformanceHoldTag"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getNonconformanceHoldTag(pg_refresh = false) {
            this.startLoader();

            this.fetchNonconformanceHoldTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.nonconformance_hold_tag) {
                    this.nonconformance_hold_tag = this.assignObj2(data.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printNonconformanceHoldTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.nonconformance_hold_tag) {
                    if (this.dev_mode) {
                        this.file_name = data.nonconformance_hold_tag.file_name;
                    } else {
                        this.$refs.print.printReport(data.nonconformance_hold_tag.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveNonconformanceHoldTags() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formNonconformanceHoldTag")) {
                    let body = this.prepForm(this.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);

                    this.saveNonconformanceHoldTag({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.nonconformance_hold_tag) {
                            this.$router.push({ name: "nonconformance_hold_tag", params: { id: data.nonconformance_hold_tag.hold_tag_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { hold_tag_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveNonconformanceHoldTags({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.nonconformance_hold_tag) {
                    this.nonconformance_hold_tag = this.assignObj2(data.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);
                }
            });
        },
        deleteNonconformanceHoldTags() {
            this.deleteNonconformanceHoldTag({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "nonconformance_hold_tags" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchNonconformanceHoldTag({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.nonconformance_hold_tag) {
                        this.nonconformance_hold_tag = this.assignObj2(data.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
